module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-ipad-76x76-46c360c1905060b231dbbaaf8dfe0c29.png";